import React from 'react';
import { Box, Flex } from '@legion-ui/core';
import { FaPencilAlt } from 'react-icons/fa';
import SearchBar from '../SearchBar';
import Button from '../Button';

interface EmailBlastListHeaderProps {
  searchTerm: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onCreateClick: () => void;
}

const EmailBlastListHeader: React.FC<EmailBlastListHeaderProps> = ({
  searchTerm,
  onSearchChange,
  onCreateClick,
}) => {
  return (
    <Box mb="1.5rem">
      <Flex
        className="flex-col md:flex-row md:gap-4 md:items-center"
      >
        {/* Search Bar */}
        <Box className="w-full md:w-96 mb-4 md:mb-0">
          <SearchBar
            value={searchTerm}
            onChange={onSearchChange}
            placeholder="Search email subject"
            showLabel={false}
            required={false}
          />
        </Box>

        {/* Spacer to push button to the right */}
        <Box className="hidden md:block md:flex-1" />

        {/* Create Email Button */}
        <Box>
          <Button
            iconLeft={<FaPencilAlt />}
            variant="solid"
            color="primary"
            size="md"
            onClick={onCreateClick}
            className="h-[42px] w-full md:w-auto"
          >
            Create Email
          </Button>
        </Box>
      </Flex>
    </Box>
  );
};

export default EmailBlastListHeader;